<template>
  <div>
    <internal-staff-unit-list
      v-if="
        $route.name === 'org-internal-staff-units'
      "></internal-staff-unit-list>
    <router-view v-else></router-view>
  </div>
</template>

<script lang="ts">
import InternalStaffUnitList from './InternalStaffUnitList.vue'

export default {
  name: 'InternalStaffUnitIndex',
  components: { InternalStaffUnitList },
}
</script>

<style lang="scss" scoped></style>
